import { useProfile } from "../context/ProfileContext";

export default function Bio() {
  const PROFILE = useProfile();
  const paragraphs = PROFILE.bio.split("\n\n");
  return (
    <section className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-white/10" data-testid="bio-section">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-24">
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
                04 — In Her Own Words
              </div>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-none mb-8">
                Driven. <br />
                <span className="text-[#8A8A8A]">Coachable.</span>
                <br />
                Faith.
              </h2>
              <div className="relative overflow-hidden border border-white/10 max-w-md">
                <img
                  src={PROFILE.images.ball}
                  alt="Faith with volleyball"
                  className="w-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-7 text-[#cfcfcf] text-base lg:text-lg leading-[1.85]">
              {paragraphs.map((p, i) => (
                <p key={i} className={i === 0 ? "first-letter:font-display first-letter:text-7xl first-letter:font-black first-letter:text-[#E60000] first-letter:float-left first-letter:mr-3 first-letter:leading-[0.9]" : ""}>
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-white/10 flex items-center justify-between gap-6 flex-wrap">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-2">
                  Signed
                </div>
                <div className="font-display text-3xl uppercase font-bold text-white tracking-tight">
                  Faith Ahyi-Sena
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#8A8A8A] mb-2">
                  Class of
                </div>
                <div className="font-display text-5xl font-black text-white tracking-tighter">
                  2027
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
